// extracted by mini-css-extract-plugin
export default {"icon":"KcIl6w"};